import React, {useMemo, useState} from 'react';
import Slider from "react-slick";
import {useDispatch, useSelector} from "react-redux";
import ReactMarkdown from "react-markdown";
import newlines from "remark-new-lines";
import breaks from "remark-breaks";

// Icon & Framework
import * as Icon from 'ubs-icons';
import {COLOR} from "ubs-framework/v2/common/constant";

// Framework Component
import NoDataFound from "ubs-framework/v2/no-data-found";

const ViewRelease = React.memo((props) => {
    const DISPATCH = useDispatch();

    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);

    const leaveTypeSlider = useMemo(() => {
        return {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            adaptiveHeight: true,
            draggable: false,
            prevArrow: <button type="button" className="slick-prev"><Icon.RightArrow fill={COLOR.u_white} size={10}/></button>,
            nextArrow: <button type="button" className="slick-next"><Icon.RightArrow fill={COLOR.u_white} size={10}/></button>,
        }
    }, []);

    // Img File Pop-Up Zoom
    const openFile = (data, i) => {
        DISPATCH({type: 'SET_FILES', payload: {files: data?.files, active: i || 0}})
    }

    return (
        <React.Fragment>
            <div className="u_release-note-slider u-mb-30">
                {props?.data?.length === 0 ? <NoDataFound/> :
                    (props?.data?.map((data,i) => {
                        return <React.Fragment key={data?._id}>
                            <div className="u_release-note-container">
                                <div className="u_feature">
                                    <div className="u_rn-icon"><Icon.Forward size={18} fill={COLOR.u_green}/></div>
                                    <div className="u_rn-text">
                                        <div className="u_flex u-align-center u_mb-5"><h3>{data?.title}</h3>
                                            <span
                                                className={data?.type === 'BUG' ? 'u_rn-text-bug' : data?.type === 'NEW' ? 'u_rn-text-new' : 'u_rn-text-enhancement'}>{data?.type}</span>
                                        </div>
                                        <p>
                                            <ReactMarkdown
                                                source={data?.description}
                                                parserOptions={{commonmark: true}}
                                                plugins={[newlines, breaks]}
                                                sourcePos={true}
                                                rawSourcePos={true}
                                                includeNodeIndex={true}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="u_m-20">
                                <Slider {...leaveTypeSlider}>
                                    {data?.files?.map((img, i) => {
                                        return <div key={img._id} className="u_relative u_rn-open-image">
                                            <img src={_S3_BASE_URL + img.url} alt={img.model} className="u_m-auto"/>
                                            <div onClick={() => openFile(data, i)}><span
                                                className="u_rn-open-image-inner u_cp"><Icon.Eye fill={COLOR.u_white}
                                                                                           size={18}/></span></div>
                                        </div>
                                    })}
                                </Slider>
                            </div>

                        </React.Fragment>
                    }))}
            </div>
        </React.Fragment>

    );
});

export default ViewRelease;